// https://codesandbox.io/p/sandbox/tutorial-multiple-rbd-i2wm6?file=%2Fsrc%2FApp.js%3A4%2C15

import React, { memo } from "react";
import PropTypes from "prop-types";
import { Droppable } from "@hello-pangea/dnd";

import TaskCard from "./TaskCard";

const Column = ({ droppableId, column, onClick, dragDisabled }) => (
  <Droppable droppableId={droppableId} column={column} key={droppableId}>
    {(provided, snapshot) => {
      return (
        <div
          {...provided.droppableProps}
          ref={provided.innerRef}
          style={{
            display: "flex",
            flexFlow: "column nowrap",
            alignItems: "flex-start",
            justifyContent: "flex-start",
            gap: 16,
            width: "100%",
            minHeight: "100%"
          }}
        >
          {column?.items?.map((item, index) => {
            return (
              <TaskCard
                dragDisabled={dragDisabled}
                onClick={onClick}
                key={item.id}
                item={item}
                index={index}
              />
            );
          })}
          {provided.placeholder}
        </div>
      );
    }}
  </Droppable>
);

Column.propTypes = {
	column: PropTypes.object,
	droppableId: PropTypes.string,
};

export default memo(Column);
